import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, mergeMap, tap } from 'rxjs/operators';
import { GroupsOfGroupStoreActions, GroupsOfGroupStoreSelectors } from '../groups-of-group';
import { AclRouterStoreSelectors } from '../router';

@Injectable({ providedIn: 'root' })
export class GroupsOfGroupResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(AclRouterStoreSelectors.selectCurrentAclId).pipe(
      mergeMap((x) =>
        this.store.select(GroupsOfGroupStoreSelectors.selectParentGroups(x ?? '')).pipe(
          tap((y) => {
            if (y.length < 1) {
              this.store.dispatch(
                GroupsOfGroupStoreActions.GroupsOfGroupResolverActions.userGroupsRequested({ groupId: x ?? '' })
              );
            }
          })
        )
      ),
      map(() => true),
      first()
    );
  }
}
